import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {CountryStatesIndraService} from '@ibe.services/country-states-indra.service';
import * as fromActions from '../actions/country-state.actions';
import {map, switchMap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Action} from '@ngrx/store';

@Injectable()
export class CountryStateEffects {

	constructor(
		private actions$: Actions,
		private service: CountryStatesIndraService
	) { }

	@Effect()
	loadCountryCodes$: Observable<Action> = this.actions$.pipe(
		ofType(fromActions.ActionTypes.LOAD_COUNTRY_CODES),
		switchMap(() => this.service.getCountryCodes()),
		map((data: any) => new fromActions.LoadCountryCodesSuccess(data))
	);

	@Effect()
	loadCountryConversionCodes$: Observable<Action> = this.actions$.pipe(
		ofType(fromActions.ActionTypes.LOAD_COUNTRY_CONVERSION_CODES),
		switchMap(() => this.service.getCountryConversionCodes()),
		map((data: any) => new fromActions.LoadCountryConversionCodesSuccess(data))
	);

	@Effect()
	loadUSAirports$: Observable<Action> = this.actions$.pipe(
		ofType(fromActions.ActionTypes.LOAD_US_AIRPORTS),
		switchMap(() => this.service.getUSAirports()),
		map((data: any) => new fromActions.LoadUSAirportsSuccess(data))
	);

	@Effect()
	loadUSStates$: Observable<Action> = this.actions$.pipe(
		ofType(fromActions.ActionTypes.LOAD_US_STATES),
		switchMap(() => this.service.getUSStates()),
		map((data: any) => new fromActions.LoadUSStatesSuccess(data))
	);

	@Effect()
	loadSchengenCountryCodes$: Observable<Action> = this.actions$.pipe(
		ofType(fromActions.ActionTypes.LOAD_SCHENGEN_COUNTRY_CODES),
		switchMap(() => this.service.getSchengenCountryCodes()),
		map((data: any) => new fromActions.LoadSchengenCountryCodesSuccess(data))
	);

	@Effect()
	loadEUCountryCodes$: Observable<Action> = this.actions$.pipe(
		ofType(fromActions.ActionTypes.LOAD_EU_COUNTRY_CODES),
		switchMap(() => this.service.getEUCountryCodes()),
		map((data: any) => new fromActions.LoadEUCountryCodesSuccess(data))
	);
}
